/* eslint-disable @typescript-eslint/no-empty-function */
import { TMultiMedia } from 'news/utils/types';
import React, {
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
export type TWithSelectInput = {
  icon: ReactElement;
  placeholder: string;
  options: any[];
  name: string;
  onChange?: (x: any) => void;
  disableOkUntilSelect?: boolean;
  isReport?: boolean;
};
export type TWithSelectAutocomplete = {
  icon: ReactElement;
  placeholder: string;
  keyExtractor: string;
  isMulti: boolean;
  autoCompleteModule: string;
  onChange?: (x: any) => void;
};
export type TWithTextInput = {
  placeholder: string;
  name: string;
  label: string;
  isMandatory: boolean;
  onChange?: (x: any) => void;
};
type TModal = {
  status?: boolean;
  message?: string;
  smallMessage?: string;
  onOk?: (x?: any, filters?: any, checkbox?: any, textValue?: string) => any;
  onCancel?: any;
  isAlternative?: boolean;
  onOkText?: string;
  onCancelText?: string;
  hideCancel?: boolean;
  preventBGCancel?: boolean;
  imageUrl?: string;
  imageUrls?: TMultiMedia[];
  imageIndex?: number;
  videoUrl?: string;
  instaVideoUrl?: string;
  openLink?: string;
  linkText?: string;
  autoHide?: boolean;
  withSelectInput?: TWithSelectInput | null;
  withCheckboxGroup?: any;
  withSelectAutocomplete?: TWithSelectAutocomplete | null;
  withTextInput?: TWithTextInput | null;
  notAuthorizeCb?: () => void;
  unMountCb?: () => void;
  withDate?: boolean;
  checkboxCondition?: string;
  withQuestionPopup?: boolean;
  nonUseLoader?: boolean;
  instaMediaUrls?: TMultiMedia[];
  customStyle?: any;
  withCollectSectionPopup?: {
    register: any;
    errors: any;
    handleSubmit: any;
    setError: any;
    getValues: any;
    watch: any;
    setValue: any;
    handleClick: any;
    isLoading: any;
    eyeValidate: any;
    setIsOpenPopup?: any;
    url?: string;
    isOpenPopup?: boolean;
    categoryName?: string;
  };
};

export type ModalContextType = {
  show: (modal: TModal) => void;
  hide: (cb?: () => void) => any;
  modal: TModal;
  setIsDisabled: any;
  isDisabled: boolean;
};

export const ModalContext = createContext<ModalContextType | null>(null);

export const ModalProvider = ({
  children,
  openModalProp,
}: {
  children: React.ReactNode;
  openModalProp: TModal;
}): JSX.Element | null => {
  const initState: TModal = {
    isAlternative: false,
    status: false,
    message: '',
    smallMessage: '',
    onCancel: undefined,
    onOk: undefined,
    onOkText: '',
    onCancelText: '',
    hideCancel: false,
    preventBGCancel: false,
    autoHide: true,
    openLink: '',
    linkText: '',
    withSelectInput: null,
    withSelectAutocomplete: null,
    withTextInput: null,
    unMountCb: undefined,
    withDate: false,
    checkboxCondition: '',
    withQuestionPopup: false,
    nonUseLoader: false,
    withCollectSectionPopup: undefined,
  };
  const [isDisabled, setIsDisabled] = useState(false);
  const [modal, setModal] = useState<TModal>(initState);
  const value = useMemo(
    () => ({
      modal,
      show: (modalData: TModal) => {
        setModal(() => ({
          ...initState,
          status: true,

          ...modalData,
        }));
      },
      setIsDisabled,
      isDisabled,
      hide: (cb?: () => void) => {
        setModal(initState);
        setIsDisabled(false);
        if (typeof cb === 'function') {
          cb?.();
        }
      },
    }),

    [modal, isDisabled],
  );

  useEffect(() => {
    document.body.classList.remove('no-Events');
    if (openModalProp) {
      setModal((old: TModal) => ({
        ...old,
        status: true,
        ...openModalProp,
      }));
    }
  }, [openModalProp]);

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) throw Error('useModal should be used within <ModalProvider />');
  return context;
};
